// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Possible values for device state that represent a transition between states
 * @export
 */
export const UATransition = {
    FromExecutingToExecuting: 'fromExecutingToExecuting',
    FromExecutingToNotAvailable: 'fromExecutingToNotAvailable',
    FromExecutingToOutOfService: 'fromExecutingToOutOfService',
    FromNotAvailableToExecuting: 'fromNotAvailableToExecuting',
    FromNotAvailableToNotAvailable: 'fromNotAvailableToNotAvailable',
    FromNotAvailableToNotExecuting: 'fromNotAvailableToNotExecuting',
    FromNotAvailableToOutOfService: 'fromNotAvailableToOutOfService',
    FromNotExecutingToExecuting: 'fromNotExecutingToExecuting',
    FromNotExecutingToNotAvailable: 'fromNotExecutingToNotAvailable',
    FromNotExecutingToNotExecuting: 'fromNotExecutingToNotExecuting',
    FromNotExecutingToOutOfService: 'fromNotExecutingToOutOfService',
    FromOutOfServiceToExecuting: 'fromOutOfServiceToExecuting',
    FromOutOfServiceToNotAvailable: 'fromOutOfServiceToNotAvailable',
    FromOutOfServiceToNotExecuting: 'fromOutOfServiceToNotExecuting',
    FromOutOfServiceToOutOfService: 'fromOutOfServiceToOutOfService'
} as const;
export type UATransition = typeof UATransition[keyof typeof UATransition];


export function instanceOfUATransition(value: any): boolean {
    for (const key in UATransition) {
        if (Object.prototype.hasOwnProperty.call(UATransition, key)) {
            if (UATransition[key as keyof typeof UATransition] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UATransitionFromJSON(json: any): UATransition {
    return UATransitionFromJSONTyped(json, false);
}

export function UATransitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UATransition {
    return json as UATransition;
}

export function UATransitionToJSON(value?: UATransition | null): any {
    return value as any;
}

export function UATransitionToJSONTyped(value: any, ignoreDiscriminator: boolean): UATransition {
    return value as UATransition;
}

